import {HierarchyApi} from 'Agent/AgentInformation/api/api';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';

const hierarchyApi = new HierarchyApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

const getHierarchyByAgentNumber = (agentNumber: string, isNewYork: boolean, encryptedIdentifier: string) =>
  hierarchyApi
    .getAgentsHierarchy(agentNumber, '1', isNewYork, {params: {encryptedIdentifier}, ...getAxiosConfig()})
    .then(handleResponse);

export default {
  getHierarchyByAgentNumber,
};
